<template>
  <div class="tibco">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">TIBCO</h3>
      </section>
      <section class="sub-body-content">
        
        <v-container fluid>
          <h5 class="text-h6 text-md-h5 font-weight-bold mb-3">TIBCO 개요</h5>
          <v-row class="align-stretch">
            <v-col cols="12" class="d-flex align-stretch">

              <v-card width="100%" class="pa-10" outlined style="background:transparent">
                <v-row class="align-center mt-0">
                  <v-col cols="12" sm="7">
                    <v-img contain :src="require('@/assets/img_sub_prod_tibco01.svg')" max-height="205"></v-img>
                  </v-col>
                  <v-col cols="12" sm="5">
                    TIBCO는 이질적인 시스템들의 
                    <span style="color:#00A9D7">연계 (connect)</span>
                    , 데이터의 
                    <span style="color:#80BC00">통합 (unify)</span>
                    , 고급 분석을 통해 미래를 
                    <span style="color:#FFA400">예측 (predict)</span>
                    하기 위한 선진 솔루션을 제공해 난제를 해결하도록 지원합니다.
                  </v-col>
                </v-row>
              </v-card>

            </v-col>
          </v-row>
          
          <h5 class="text-h6 text-md-h5 font-weight-bold mb-3 mt-12">TIBCO Solution Overview</h5>
          <v-img contain :src="require('@/assets/img_sub_prod_tibco02.svg')" max-height="438"></v-img>
          
          <h5 class="text-h6 text-md-h5 font-weight-bold mt-12">TIBCO Connected Intelligence</h5>
          <v-img contain :src="require('@/assets/img_sub_prod_tibco03.svg')" max-height="670"></v-img>


          <v-row class="mt-16 justify-center">
            <v-btn outlined x-large href="https://www.tibco.com/" target="_blank">TIBCO</v-btn>
          </v-row>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'tibco',
  data() {
    return {
    };
  },

  created () {
  },

  mounted: function(){
    
    gsap.from(".tibco .sub-body-title", {
      scrollTrigger: {
        trigger: ".tibco .sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".tibco .sub-body-content", {
      scrollTrigger: {
        trigger: ".tibco .sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: 1, y: 50, opacity: 0, stagger: .3, delay: .3
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>